export default __webpack_public_path__ + "static/media/dashboard_ico.f57594f5.svg";